import { render, staticRenderFns } from "./StatisticsConsultations.vue?vue&type=template&id=4b857fde&scoped=true"
import script from "./StatisticsConsultations.vue?vue&type=script&lang=js"
export * from "./StatisticsConsultations.vue?vue&type=script&lang=js"
import style0 from "./StatisticsConsultations.vue?vue&type=style&index=0&id=4b857fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b857fde",
  null
  
)

export default component.exports